<template>
  <div class="container">
    <div class="row">
      <div class="small-12 columns small-centered text-center">
        <h3>A kért oldal nem található</h3>
      </div>
    </div>
    <div class="row">
      <div class="small-2 columns small-centered">
        <a @click.prevent="goBack" class="button primary trans-uppercase">Vissza</a>
      </div>
    </div>
    <div class="row">
      <div class="small-2 columns small-centered">
        <router-link to="/" class="button secondary trans-uppercase">Nyitóoldal</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pagenotfound',
  data () {
    return {
    }
  },
  methods: {
    goBack () {
      window.history.back()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '../../sass/foundation-import';
  .container {
    padding: $global-margin *4;

    .button {
      width: 100%;
      margin: $global-margin 0 $global-margin/2 0;
    }
  }
</style>



// WEBPACK FOOTER //
// PageNotFound.vue?73e9b872